var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadVideoClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 32141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2759 16.6975V3.99344C27.2759 2.62205 26.1539 1.5 24.7825 1.5H8.45669L1.5 7.54035V32.5246C1.5 33.896 2.62205 35.018 3.99344 35.018H19.247",
    stroke: "#EA429D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.57876 1.97998V9.65354H5.0033",
    stroke: "#EA429D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 32140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.093 23.3033H31.329C31.7806 23.3033 32.1481 23.6708 32.1481 24.1224V31.3438C32.1481 31.7954 31.7806 32.1629 31.329 32.1629H22.093C21.6414 32.1629 21.2739 31.7954 21.2739 31.3438V24.1224C21.2739 23.6708 21.6414 23.3033 22.093 23.3033Z",
    stroke: "#EA429D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.7112 26.925V29.5063",
    stroke: "#EA429D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.1982 26.8144C27.1982 27.0844 26.9812 27.3014 26.7112 27.3014C26.4411 27.3014 26.2241 27.0844 26.2241 26.8144C26.2241 26.5443 26.4455 26.3273 26.7112 26.3273C26.9768 26.3273 27.1982 26.5443 27.1982 26.8144Z",
    fill: "#EA429D",
    stroke: "#EA429D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.0273 23.2369V21.7802C30.0273 20.4033 28.8983 19.2742 27.5213 19.2742H25.9008C24.5238 19.2742 23.3948 20.4033 23.3948 21.7802V23.2369",
    stroke: "#EA429D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 247",
    d: "M14.7207 12.7208V24.7208M14.7207 12.7208L10.7207 17.2922M14.7207 12.7208L18.7207 17.2922",
    stroke: "#EA429D",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideoClosed);
export default __webpack_public_path__ + "static/media/uploadVideoClosed.872d9bcf2cacc417fa51fceef30f3fbc.svg";
export { ForwardRef as ReactComponent };